export const SUPPORT_REASONS = [
  { value: 'question', label: 'Вопрос' },
  { value: 'cancellation', label: 'Отмена' },
  { value: 'review', label: 'Отзыв' },
  { value: 'other', label: 'Другое' },
];

export const MAX_SUPPORT_MESSAGE_LENGTH = 500;

export const REASONS_WITH_MESSAGE = ['question', 'review', 'other'];
